export const LOAD_TOURISMEVENTS = 'LOAD_TOURISMEVENTS';
export const CREATE_TOURISMEVENT = 'CREATE_TOURISMEVENT';
export const DELETE_TOURISMEVENT = 'DELETE_TOURISMEVENT';
export const MODIFY_TOURISMEVENT = 'MODIFY_TOURISMEVENT';
export const LOAD_INFORMATIVETEXTS = 'LOAD_INFORMATIVETEXTS';
export const MODIFY_INFORMATIVETEXT = 'MODIFY_INFORMATIVETEXT';


export const ONFINISHED_DELETE_TOURISMEVENT = 'ONFINISHED_DELETE_TOURISMEVENT';
export const ONFINISHED_CREATE_TOURISMEVENT = 'ONFINISHED_CREATE_TOURISMEVENT';
export const ONFINISHED_MODIFY_TOURISMEVENT = 'ONFINISHED_MODIFY_TOURISMEVENT';
export const ONFINISHED_MODIFY_INFORMATIVETEXT = 'ONFINISHED_MODIFY_INFORMATIVETEXT';

export const OPENCLOSE_SIDEMENU = 'OPENCLOSE_SIDEMENU';
export const OPEN_FORMMENU = 'OPEN_FORMMENU';
export const OPEN_LISTMENU = 'OPEN_LISTMENU';
export const OPEN_TEXTSMENU = 'OPEN_TEXTSMENU';

export const UPLOADING_IMAGE = 'UPLOADING_IMAGE';

export const SET_MODIFY_TOURISMEVENT = 'SET_MODIFY_TOURISMEVENT';
export const SET_MODIFY_INFORMATIVETEXT = 'SET_MODIFY_INFORMATIVETEXT';
